"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prism = require("react-syntax-highlighter/prism");

var _prism2 = _interopRequireDefault(_prism);

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _prism3 = require("react-syntax-highlighter/styles/prism");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

// import syntax from "./theme";

var Highlighter = function Highlighter(props) {
  var language = props.language;
  if (language === "ipython") {
    language = "python";
  } else if (language === "text/x-scala") {
    // Adjust for the scala codemirror type
    language = "scala";
  } else if (language.startsWith("text/x-")) {
    // Strip off the language from the mimetype
    language = language.slice("text/x-".length);
  }

  return React.createElement(
    _prism2.default,
    {
      style: props.theme === "light" ? _prism3.vs : _prism3.xonokai,
      language: language,
      className: props.className,
      customStyle: {
        padding: "10px 0px 10px 10px",
        margin: "0px",
        backgroundColor: "var(--cm-background, #fafafa)",
        border: "none"
      }
    },
    props.children
  );
};

Highlighter.defaultProps = {
  theme: "light",
  language: "text",
  children: "",
  className: "input"
};

var _default = Highlighter;
exports.default = _default;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Highlighter, "Highlighter", "src/syntax-highlighter/index.js");
  reactHotLoader.register(_default, "default", "src/syntax-highlighter/index.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/presentational-components/lib/syntax-highlighter/index.js
// module id = 123
// module chunks = 186292428941015